import { defineStore } from "pinia";

export const useUiStore = defineStore("ui", {
  state: () => ({
    reduce: false,
  }),
  actions: {
    reduceNavbar() {
      this.reduce = true;
    },
    expandNavbar() {
      this.reduce = false;
    },
  },
});
